import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SuperAdminDAshboardComponent } from './Layouts/super-admin-dashboard/super-admin-dashboard.component';
import { AdminDashboardComponent } from './Layouts/admin-dashboard/admin-dashboard.component';
import { CompanyEmployeeComponent } from './Layouts/company-employee/company-employee.component';
import {AuthGuard} from "./_guards";

const routes: Routes = [
  // {
  //   path: '',
  //   redirectTo: 'home',
  // },
  {
    path: '',
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule),
  },
  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then(m => m.LoginModule),
  },
  {
    path: 'terms',
    loadChildren: () => import('./login/terms/terms.module').then(m => m.TermsModule)
  },

  {
    path: 'welcome',
    loadChildren: () => import('./login/welcome/welcome.module').then(m => m.WelcomeModule)
  },
  {
    path: 'resetpassword',
    loadChildren: () => import('./login/login.module').then(m => m.LoginModule),
  },



  {
    path: '',
    component: SuperAdminDAshboardComponent,
    children: [
      {
        path: 'SuperAdminHome',
        loadChildren: () => import('./Layouts/super-admin-dashboard/home/home.module').then(m => m.HomeModule),
        canActivate: [ AuthGuard ]
      },
      {
        path: 'Profile-details',
        loadChildren: () => import('./Layouts/super-admin-dashboard/profile-details/profile-details.module').then(m => m.ProfileDetailsModule),
        canActivate: [ AuthGuard ]
      },
      {
        path: 'Change-pwd',
        loadChildren: () => import('./Layouts/super-admin-dashboard/change-pwd/change-pwd.module').then(m => m.ChangePwdModule),
        canActivate: [ AuthGuard ]
      },

      {
        path: 'addcompany',
        loadChildren: () => import('./Layouts/super-admin-dashboard/add-company/add-company.module').then(m => m.AddCompanyModule),
        canActivate: [ AuthGuard ]
      },
      {
        path: 'managecompanies',
        loadChildren: () => import('./Layouts/super-admin-dashboard/manage-companies/manage-companies.module').then(m => m.ManageCompaniesModule),
        canActivate: [ AuthGuard ]
      },
      {
        path: 'reports',
        loadChildren: () => import('./Layouts/super-admin-dashboard/reports/reports.module').then(m => m.ReportsModule),
        canActivate: [ AuthGuard ]
      },
      {
        path: 'editcompany',
        loadChildren: () => import('./Layouts/super-admin-dashboard/edit-company/edit-company.module').then(m => m.EditCompanyModule),
        canActivate: [ AuthGuard ]
      },
      {
        path: 'allusers',
        loadChildren: () => import('./Layouts/super-admin-dashboard/all-users/all-users.module').then(m => m.AllUsersModule),
        canActivate: [ AuthGuard ]
      },
      {
        path: 'globalprocedures',
        loadChildren: () => import('./Layouts/super-admin-dashboard/global-procedures/global-procedures.module').then(m => m.GlobalProceduresModule),
        canActivate: [ AuthGuard ]
      },
      {
        path: 'clientguides',
        loadChildren: () => import('./Layouts/super-admin-dashboard/client-guides/client-guides.module').then(m => m.ClientGuidesModule),
        canActivate: [ AuthGuard ]
      },
      {
        path: 'clientonboarding',
        loadComponent: () => import('./Layouts/super-admin-dashboard/client-onboarding/client-onboarding.component').then(m => m.ClientOnboardingComponent),
        canActivate: [ AuthGuard ]
      },
      {
        path: 'addons',
        loadComponent: () => import('./Layouts/super-admin-dashboard/addons/addons.component').then(m => m.AddonsComponent),
        canActivate: [ AuthGuard ]
      }
    ]
  },

  {
    path: '',
    component: AdminDashboardComponent,
    children: [
      {
        path: 'AdminHome',
        loadChildren: () => import('./Layouts/admin-dashboard/home/home.module').then(m => m.HomeModule),
        canActivate: [ AuthGuard ]
      },
      {
        path: 'Profile',
        loadChildren: () => import('./Layouts/admin-dashboard/profile/profile.module').then(m => m.ProfileModule),
        canActivate: [ AuthGuard ]
      },
      {
        path: 'Change-password',
        loadChildren: () => import('./Layouts/admin-dashboard/change-password/change-password.module').then(m => m.ChangePasswordModule),
        canActivate: [ AuthGuard ]
      },
      {
        path: 'Traceability',
        loadChildren: () => import('./Layouts/admin-dashboard/traceability/traceability.module').then(m => m.TraceabilityModule),
        canActivate: [ AuthGuard ]
      },
      {
        path: 'Material-traceability',
        loadChildren: () => import('./Layouts/admin-dashboard/traceability/material-traceability/material-traceability.module').then(m => m.MaterialTraceabilityModule),
        canActivate: [ AuthGuard ]
      },
      {
        path: 'Material-traceability-details',
        loadChildren: () => import('./Layouts/admin-dashboard/traceability/material-traceability/material-traceability-details/material-traceability-details.module').then(m => m.MaterialTraceabilityDetailsModule),
        canActivate: [ AuthGuard ]
      },
      {
        path: 'Product-traceability',
        loadChildren: () => import('./Layouts/admin-dashboard/traceability/product-traceability/product-traceability.module').then(m => m.ProductTraceabilityModule),
        canActivate: [ AuthGuard ]
      },
      {
        path: 'Product-traceability-details',
        loadChildren: () => import('./Layouts/admin-dashboard/traceability/product-traceability/product-traceability-details/product-traceability-details.module').then(m => m.ProductTraceabilityDetailsModule),
        canActivate: [ AuthGuard ]
      },
      {
        path: 'Manage-Users',
        loadChildren: () => import('./Layouts/admin-dashboard/manage-users/manage-users.module').then(m => m.ManageUsersModule),
        canActivate: [ AuthGuard ]
      },
      {
        path: 'License-And-Billing',
        loadChildren: () => import('./Layouts/admin-dashboard/license-billing/license-billing.module').then(m => m.LicenseBillingModule),
        canActivate: [ AuthGuard ]
      },
      {
        path: 'Admin-Reports',
        loadChildren: () => import('./Layouts/admin-dashboard/admin-reports/admin-reports.module').then(m => m.AdminReportsModule),
        canActivate: [ AuthGuard ]
      },

      {
        path: 'Add-New-User',
        loadChildren: () => import('./Layouts/admin-dashboard/manage-users/add-new-user/add-new-user.module').then(m => m.AddNewUserModule),
        canActivate: [ AuthGuard ]
      },
      {
        path: 'Edit-User',
        loadChildren: () => import('./Layouts/admin-dashboard/manage-users/edit-user/edit-user.module').then(m => m.EditUserModule),
        canActivate: [ AuthGuard ]
      },

      {
        path: 'Customers',
        loadChildren: () => import('./Layouts/admin-dashboard/customers/customers.module').then(m => m.CustomersModule),
        canActivate: [ AuthGuard ]
      },
      {
        path: 'Add-customer',
        loadChildren: () => import('./Layouts/admin-dashboard/customers/add-customer/add-customer.module').then(m => m.AddCustomerModule),
        canActivate: [ AuthGuard ]
      },
      {
        path: 'Edit-customer',
        loadChildren: () => import('./Layouts/admin-dashboard/customers/edit-customer/edit-customer.module').then(m => m.EditCustomerModule),
        canActivate: [ AuthGuard ]
      },
      {
        path : 'Forecast-Sales',
        loadChildren: () => import('./Layouts/admin-dashboard/forecast-scheduler/forecast-scheduler.module').then(m => m.ForecastSchedulerModule),
        canActivate: [ AuthGuard ]
      },
      {
        path : 'Forecast-Add',
        loadChildren: () => import('./Layouts/admin-dashboard/forecast-scheduler/forecast-add/forecast-add.module').then(m => m.ForecastAddModule),
        canActivate: [ AuthGuard ]
      },
      {
        path : 'Product-Inventory',
        loadChildren: () => import('./Layouts/admin-dashboard/forecast-scheduler/product-inventory/product-inventory.module').then(m => m.ProductInventoryModule),
        canActivate: [ AuthGuard ]
      },
      {
        path : 'Product-Details',
        loadChildren: () => import('./Layouts/admin-dashboard/forecast-scheduler/product-details/product-details.module').then(m => m.ProductDetailsModule),
        canActivate: [ AuthGuard ]
      },

      {
        path: 'PO-Management',
        loadChildren: () => import('./Layouts/admin-dashboard/po-management/po-management.module').then(m => m.POManagementModule),
        canActivate: [ AuthGuard ]
      },
      {
        path: 'Add-PO',
        loadChildren: () => import('./Layouts/admin-dashboard/po-management/add-po/add-po.module').then(m => m.AddPoModule),
        canActivate: [ AuthGuard ]
      },
      {
        path: 'Edit-PO',
        loadChildren: () => import('./Layouts/admin-dashboard/po-management/edit-po/edit-po.module').then(m => m.EditPoModule),
        canActivate: [ AuthGuard ]
      },
      {
        path: 'Warehouse',
        loadChildren: () => import('./Layouts/admin-dashboard/warehouse/warehouse.module').then(m => m.WarehouseModule),
        canActivate: [ AuthGuard ]
      },
      {
        path: 'Purchase-orders',
        loadChildren: () => import('./Layouts/admin-dashboard/warehouse/purchase-orders/purchase-orders.module').then(m => m.PurchaseOrdersModule),
        canActivate: [ AuthGuard ]
      },
      {
        path: 'Closed-Pos',
        loadChildren: () => import('./Layouts/admin-dashboard/po-management//closed-po/closed-po.module').then(m => m.ClosedPoModule),
        canActivate: [ AuthGuard ]
      },
      {
        path: 'Closed-WPO',
        loadChildren: () => import('./Layouts/admin-dashboard/po-management//closed-po/closed-po.module').then(m => m.ClosedPoModule),
        canActivate: [ AuthGuard ]
      },
      {
        path: 'Edit-Purchase-orders',
        loadChildren: () => import('./Layouts/admin-dashboard/warehouse/purchase-orders/edit-purchase-orders/edit-purchase-orders.module').then(m => m.EditPurchaseOrdersModule),
        canActivate: [ AuthGuard ]
      },
      {
        path: 'Receive-material',
        loadChildren: () => import('./Layouts/admin-dashboard/warehouse/purchase-orders/receive-material/receive-material.module').then(m => m.ReceiveMaterialModule),
        canActivate: [ AuthGuard ]
      },
      {
        path: 'Received-Lots',
        loadChildren: () => import('./Layouts/admin-dashboard/warehouse/purchase-orders/received-lots/received-lots.module').then(m => m.ReceivedLotsModule),
        canActivate: [ AuthGuard ]
      },
      {
        path: 'Edit-Received-Lots',
        loadChildren: () => import('./Layouts/admin-dashboard/warehouse/purchase-orders/received-lots/edit-received-lots/edit-received-lots.module').then(m => m.EditReceivedLotsModule),
        canActivate: [ AuthGuard ]
      },

       {
        path: 'Dispatch-orders',
        loadChildren: () => import('./Layouts/admin-dashboard/warehouse/dispatch-orders/dispatch-orders.module').then(m => m.DispatchOrdersModule),
         canActivate: [ AuthGuard ]
      },
       {
        path: 'Do-details',
        loadChildren: () => import('./Layouts/admin-dashboard/warehouse/dispatch-orders/do-details/do-details.module').then(m => m.DoDetailsModule),
         canActivate: [ AuthGuard ]
      },
      {
        path: 'Create-Packslips',
        loadChildren: () => import('./Layouts/admin-dashboard/warehouse/dispatch-orders/create-packslips/create-packslips.module').then(m => m.CreatePackslipsModule),
        canActivate: [ AuthGuard ]
      },
      {
        path: 'Packing-Slips',
        loadChildren: () => import('./Layouts/admin-dashboard/warehouse/dispatch-orders/packing-slips/packing-slips.module').then(m => m.PackingSlipsModule),
        canActivate: [ AuthGuard ]
      },
      {
        path: 'Edit-Packslips',
        loadChildren: () => import('./Layouts/admin-dashboard/warehouse/dispatch-orders/packing-slips/edit-packslips/edit-packslips.module').then(m => m.EditPackslipsModule),
        canActivate: [ AuthGuard ]
      },
      {
        path: 'Rejected-material/product',
        loadChildren: () => import('./Layouts/admin-dashboard/warehouse/rejected-materials/rejected-materials.module').then(m => m.RejectedMaterialsModule),
        canActivate: [ AuthGuard ]
      },
      // S216 P443 (Minty): the one-lot MR forms for products and materials are retired - the MR sheets replace them.
      {
        // S215 P442: month-end write-off of leftovers on material lots.
        path: 'Stock-correction',
        loadComponent: () => import('./Layouts/admin-dashboard/warehouse/rejected-materials/stock-correction/stock-correction.component').then(m => m.StockCorrectionComponent),
        canActivate: [ AuthGuard ]
      },
      {
        // S216 P443: MR Products - the same sheet for product lots.
        path: 'Stock-correction-products',
        loadComponent: () => import('./Layouts/admin-dashboard/warehouse/rejected-materials/stock-correction/stock-correction.component').then(m => m.StockCorrectionComponent),
        data: { kind: 'products' },
        canActivate: [ AuthGuard ]
      },
      {
        path: 'Edit-reject-materials',
        loadChildren: () => import('./Layouts/admin-dashboard/warehouse/rejected-materials/edit-reject-mat/edit-reject-mat.module').then(m => m.EditRejectMatModule),
        canActivate: [ AuthGuard ]
      },
     {
        path: 'Edit-reject-product',
        loadChildren: () => import('./Layouts/admin-dashboard/warehouse/rejected-materials/edit-reject-product/edit-reject-product.module').then(m => m.EditRejectProductModule),
       canActivate: [ AuthGuard ]
      },
      {
        path: 'Older-MLCs',
        loadChildren: () => import('./Layouts/admin-dashboard/warehouse/older-mlc/older-mlc.module').then(m => m.OlderMlcModule),
        canActivate: [ AuthGuard ]
      },
      {
        path: 'Mfg-lot-codes',
        loadChildren: () => import('./Layouts/admin-dashboard/warehouse/mfg-lot-codes/mfg-lot-codes.module').then(m => m.MfgLotCodesModule),
        canActivate: [ AuthGuard ]
      },
      {
        path: 'Closed-Mfg-lot-codes',
        loadChildren: () => import('./Layouts/admin-dashboard/warehouse/closed-mfg-lot-codes/closed-mfg-lot-codes.module').then(m => m.ClosedMfgLotCodesModule),
        canActivate: [ AuthGuard ]
      },
      {
        path: 'Mat-SOH-confirmation',
        loadChildren: () => import('./Layouts/admin-dashboard/warehouse/mat-soh-confirmation/mat-soh-confirmation.module').then(m => m.MatSohConfirmationModule),
        canActivate: [ AuthGuard ]
      },
      {
        path: 'Reports',
        loadChildren: () => import('./Layouts/admin-dashboard/warehouse/reports/reports.module').then(m => m.ReportsModule),
        canActivate: [ AuthGuard ]
      },
      {
        path: 'Edit-Mlc',
        loadChildren: () => import('./Layouts/admin-dashboard/warehouse/mfg-lot-codes/edit-mlc/edit-mlc.module').then(m => m.EditMlcModule),
        canActivate: [ AuthGuard ]
      },

      {
        path: 'Receive-product',
        loadChildren: () => import('./Layouts/admin-dashboard/warehouse/mfg-lot-codes/edit-mlc/receive-product/receive-product.module').then(m => m.ReceiveProductModule),
        canActivate: [ AuthGuard ]
      },
      {
        path: 'Release-Material',
        loadChildren: () => import('./Layouts/admin-dashboard/warehouse/mfg-lot-codes/release-mat/release-mat.module').then(m => m.ReleaseMatModule),
        canActivate: [ AuthGuard ]
      },
      {
        path: 'Release-mat-details',
        loadChildren: () => import('./Layouts/admin-dashboard/warehouse/mfg-lot-codes/release-mat/release-mat-details/release-mat-details.module').then(m => m.ReleaseMatDetailsModule),
        canActivate: [ AuthGuard ]
      },

      {
        path: 'Return-material',
        loadChildren: () => import('./Layouts/admin-dashboard/warehouse/mfg-lot-codes/edit-mlc/return-mat/return-mat.module').then(m => m.ReturnMatModule),
        canActivate: [ AuthGuard ]
      },
      {
        path: 'SO-Management',
        loadChildren: () => import('./Layouts/admin-dashboard/so-management/so-management.module').then(m => m.SOManagementModule),
        canActivate: [ AuthGuard ]
      },
      {
        path: 'Add-SO',
        loadChildren: () => import('./Layouts/admin-dashboard/so-management/add-sales-order/add-sales-order.module').then(m => m.AddSalesOrderModule),
        canActivate: [ AuthGuard ]
      },
      {
        path: 'Edit-SO',
        loadChildren: () => import('./Layouts/admin-dashboard/so-management/edit-sales-order/edit-sales-order.module').then(m => m.EditSalesOrderModule),
        canActivate: [ AuthGuard ]
      },
      {
        path: 'Closed-SO',
        loadChildren: () => import('./Layouts/admin-dashboard/so-management/closed-so/closed-so.module').then(m => m.ClosedSoModule),
        canActivate: [ AuthGuard ]
      },
      {
        path: 'food-safety-system',
        loadChildren: () => import('./Layouts/admin-dashboard/food-safety-system/food-safety-system.module').then(m => m.FoodSafetySystemModule),
        canActivate: [ AuthGuard ]
      },
      {
        path: 'quickbooks',
        loadChildren: () => import('./Layouts/admin-dashboard/quickbooks/quickbooks.module').then(m => m.QuickbooksModule),
        canActivate: [ AuthGuard ]
      },
      {
        path: 'Connections',
        loadComponent: () => import('./Layouts/admin-dashboard/connections/connections.component').then(m => m.ConnectionsComponent),
        canActivate: [ AuthGuard ]
      },
      {
        path: 'documents',
        loadChildren: () => import('./Layouts/admin-dashboard/food-safety-system/documents/documents.module').then(m => m.DocumentsModule),
        canActivate: [ AuthGuard ]
      },
      // {
      //   path: 'create-document',
      //   loadChildren: () => import('./Layouts/admin-dashboard/food-safety-system/documents/add-documents/add-documents.module').then(m => m.AddDocumentsModule)
      // },
      {
        path: 'edit-document',
        loadChildren: () => import('./Layouts/admin-dashboard/food-safety-system/documents/edit-documents/edit-documents.module').then(m => m.EditDocumentsModule),
        canActivate: [ AuthGuard ]
      },
      {
        path: 'haccp-component',
        loadChildren: () => import('./Layouts/admin-dashboard/food-safety-system/haccp/haccp.module').then(m => m.HaccpModule),
        canActivate: [ AuthGuard ]
      },
      {
        path: 'create-haccp',
        loadChildren: () => import('./Layouts/admin-dashboard/food-safety-system/haccp/add-haccp/add-haccp.module').then(m => m.AddHaccpModule),
        canActivate: [ AuthGuard ]
      },
      {
        path: 'edit-haccp',
        loadChildren: () => import('./Layouts/admin-dashboard/food-safety-system/haccp/edit-haccp/edit-haccp.module').then(m => m.EditHaccpModule),
        canActivate: [ AuthGuard ]
      },
      {
        path: 'view-haccp',
        loadChildren: () => import('./Layouts/admin-dashboard/food-safety-system/haccp/view-haccp/view-haccp.module').then(m => m.ViewHaccpModule),
        canActivate: [ AuthGuard ]
      },
      {
        path: 'MLO-Management',
        loadChildren: () => import('./Layouts/admin-dashboard/mlo-management/mlo-management.module').then(m => m.MLOManagementModule),
        canActivate: [ AuthGuard ]
      },
      {
        path: 'All-Material-Stock',
        loadChildren: () => import('./Layouts/admin-dashboard/all-material-stock/all-material-stock.module').then(m => m.AllMaterialStockModule),
        canActivate: [ AuthGuard ]
      },
      {
        path: 'All-Product-Stock',
        loadChildren: () => import('./Layouts/admin-dashboard/all-product-stock/all-product-stock.module').then(m => m.AllProductStockModule),
        canActivate: [ AuthGuard ]
      },
      {
        path: 'Materials',
        loadChildren: () => import('./Layouts/admin-dashboard/admin-materials/admin-materials.module').then(m => m.AdminMaterialsModule),
        canActivate: [ AuthGuard ]
      },
      {
        path: 'Formulation',
        loadChildren: () => import('./Layouts/admin-dashboard/admin-formulation/admin-formulation.module').then(m => m.AdminFormulationModule),
        canActivate: [ AuthGuard ]
      },
      {
        path: 'Store-Managemant',
        loadChildren: () => import('./Layouts/admin-dashboard/store-management/store-management.module').then(m => m.StoreManagementModule),
        canActivate: [ AuthGuard ]
      },
      {
        path: 'Manage-Materials',
        loadChildren: () => import('./Layouts/admin-dashboard/admin-materials/manage-materials/manage-materials.module').then(m => m.ManageMaterialsModule),
        canActivate: [ AuthGuard ]
      },
      {
        path: 'Mat-inventory',
        loadChildren: () => import('./Layouts/admin-dashboard/admin-materials/manage-materials/mat-inventory/mat-inventory.module').then(m => m.MatInventoryModule),
        canActivate: [ AuthGuard ]
      },
      {
        path: 'Agents',
        loadChildren: () => import('./Layouts/admin-dashboard/admin-materials/agents/agents.module').then(m => m.AgentsModule),
        canActivate: [ AuthGuard ]
      },
      {
        path: 'Manufacturers',
        loadChildren: () => import('./Layouts/admin-dashboard/admin-materials/manufacturers/manufacturers.module').then(m => m.ManufacturersModule),
        canActivate: [ AuthGuard ]
      },
      {
        path: 'Add-Materials',
        loadChildren: () => import('./Layouts/admin-dashboard/admin-materials/manage-materials/add-materials/add-materials.module').then(m => m.AddMaterialsModule),
        canActivate: [ AuthGuard ]
      },
      {
        path: 'Edit-Materials',
        loadChildren: () => import('./Layouts/admin-dashboard/admin-materials/manage-materials/edit-material/edit-material.module').then(m => m.EditMaterialModule),
        canActivate: [ AuthGuard ]
      },
      {
        path: 'View-Materials',
        loadChildren: () => import('./Layouts/admin-dashboard/admin-materials/manage-materials/view-material/view-material.module').then(m => m.ViewMaterialModule),
        canActivate: [ AuthGuard ]
      },
      {
        path: 'Add-Formulation',
        loadChildren: () => import('./Layouts/admin-dashboard/admin-formulation/add-new-formulation/add-new-formulation.module').then(m => m.AddNewFormulationModule),
        canActivate: [ AuthGuard ]
      },
      {
        path: 'Edit-Formulation',
        loadChildren: () => import('./Layouts/admin-dashboard/admin-formulation/edit-formulation/edit-formulation.module').then(m => m.EditFormulationModule),
        canActivate: [ AuthGuard ]
      },
      {
        path: 'Add-MLO',
        loadChildren: () => import('./Layouts/admin-dashboard/mlo-management/add-mlo/add-mlo.module').then(m => m.AddMLOModule),
        canActivate: [ AuthGuard ]
      },
      {
        path: 'Edit-MLO',
        loadChildren: () => import('./Layouts/admin-dashboard/mlo-management/edit-mlo/edit-mlo.module').then(m => m.EditMLOModule),
        canActivate: [ AuthGuard ]
      },
      {
        path: 'Closed-Mlcs',
        loadChildren: () => import('./Layouts/admin-dashboard/mlo-management/closed-mlcs/closed-mlcs.module').then(m => m.ClosedMlcsModule),
        canActivate: [ AuthGuard ]
      },
      {
        path: 'Closed-MLO',
        loadChildren: () => import('./Layouts/admin-dashboard/mlo-management/closed-mlcs/closed-mlcs.module').then(m => m.ClosedMlcsModule),
        canActivate: [ AuthGuard ]
      },
      {
        path: 'Edit-Closed-Mlcs',
        loadChildren: () => import('./Layouts/admin-dashboard/mlo-management/closed-mlcs/edit-closed-mlcs/edit-closed-mlcs.module').then(m => m.EditClosedMlcsModule),
        canActivate: [ AuthGuard ]
      },
      {
        path : 'Forecast-Sales',
        loadChildren: () => import('./Layouts/admin-dashboard/forecast-scheduler/forecast-scheduler.module').then(m => m.ForecastSchedulerModule),
        canActivate: [ AuthGuard ]
      },
      {
        path : 'Forecast-Add',
        loadChildren: () => import('./Layouts/admin-dashboard/forecast-scheduler/forecast-add/forecast-add.module').then(m => m.ForecastAddModule),
        canActivate: [ AuthGuard ]
      },
      {
        path : 'All-User',
        loadChildren: () => import('./Layouts/admin-dashboard/manage-users/all-users/all-users.module').then(m => m.AllUsersModule),
        canActivate: [ AuthGuard ]
      },
      {
        path : 'PO-Management',
        loadChildren: () => import('./Layouts/admin-dashboard/po-management/po-management.module').then(m => m.POManagementModule),
        canActivate: [ AuthGuard ]
      },
      {
        path : 'Production-Controller',
        loadChildren: () => import('./Layouts/admin-dashboard/production-controller/production-controller.module').then(m => m.ProductionControllerModule),
        canActivate: [ AuthGuard ]
      },
      {
        path : 'start-mlc',
        loadChildren: () => import('./Layouts/admin-dashboard/start-mlc/start-mlc.module').then(m => m.StartMLCModule),
        canActivate: [ AuthGuard ]
      }
    ]
  },

  {
    path : '',
    component : CompanyEmployeeComponent,
    children : [
      {
        path: 'EmployeeHome',
        loadChildren: () => import('./Layouts/company-employee/home/home.module').then(m => m.HomeModule),
        canActivate: [ AuthGuard ]
      },

      {
        path: 'EMP-Reports',
        loadChildren: () => import('./Layouts/admin-dashboard/admin-reports/admin-reports.module').then(m => m.AdminReportsModule),
        canActivate: [ AuthGuard ]
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {enableTracing: true})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
